"use client";

import { Modal } from "@heroui/react";
import { ArrowRight, ZoomIn } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { LandingLesson } from "./institutional-landing-lesson";
import s from "./institutional-landing.module.css";

export function LandingMaterialComparison() {
  const t = useTranslations("InstitutionalLanding.material");
  const [side, setSide] = useState<"before" | "after">("after");
  const [expanded, setExpanded] = useState(false);

  return <figure className={s.comparison}>
    <div className={s.comparisonControls} role="group" aria-label={t("comparisonLabel")}>
      <button type="button" aria-pressed={side === "before"} onClick={() => setSide("before")}>{t("before")}</button>
      <ArrowRight size={16} aria-hidden="true" />
      <button type="button" aria-pressed={side === "after"} onClick={() => setSide("after")}>{t("after")}</button>
    </div>
    <button className={s.comparisonImage} type="button" onClick={() => setExpanded(true)} aria-label={t("expand", { version: t(side) })}>
      <LandingLesson side={side} />
      <span className={s.zoomIcon}><ZoomIn size={19} aria-hidden="true" /></span>
    </button>
    <figcaption>{t("caption")}</figcaption>
    <Modal.Backdrop isOpen={expanded} onOpenChange={setExpanded}>
      <Modal.Container size="lg" placement="center" scroll="inside" className={s.imageModalContainer}>
        <Modal.Dialog className={s.imageModal}>
          <Modal.CloseTrigger aria-label={t("close")} />
          <Modal.Header><Modal.Heading>{t(side)}</Modal.Heading></Modal.Header>
          <Modal.Body><div className={s.expandedImage}><LandingLesson side={side} /></div></Modal.Body>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  </figure>;
}
